import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { createSlice } from "@reduxjs/toolkit";
import { GET_COLOR_PLATE } from "../services/apiRoutes";
import { genericGet } from "../services/apiServices";




// ✅ Async thunk (API call only once)
export const fetchColorPlate = createAsyncThunk(
    "common/fetchColorPlate",
    async (_, { rejectWithValue }) => {
        try {
            const response = await genericGet({ url: GET_COLOR_PLATE });

            if (response.data && response.data.colorPlate) {
                let newData = response.data.colorPlate.map((data, index) => ({
                    index: (index + 1).toString().padStart(2, '0'),
                    colorId: data.colorId,
                    id: data.colorId,
                    colorName: data?.colorName,
                    backgroundColor: data?.backgroundColor,
                    color: data?.color,
                }));
                return newData;
            }
            return [];
        } catch (error) {
            return rejectWithValue([]);
        }
    }
);



// const userDataString = sessionStorage.getItem("authUser");
// const userData = JSON.parse(userDataString);
// const selectedDateFormat = String(userData?.userId || "3");

// Fetch and parse the session data
const userDataString = sessionStorage.getItem("userData");
const parsedData = JSON.parse(userDataString);
const dateFormat = String(parsedData?.companyData?.dateFormatId || "1");
const languageValue = String(parsedData?.companyData?.languageId || "en");
// const languageValue = "en";  

const initialState = {
    selectedDateFormat: dateFormat,
    languageValue: languageValue,

};

const commonSlice = createSlice({
    name: "common",
    initialState,
    reducers: {
        setDateFormat: (state, action) => {
            state.selectedDateFormat = action.payload;
        },
        setLanguageValue: (state, action) => {
            state.languageValue = action.payload;
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchColorPlate.pending, (state) => {
                state.loadingColorPlate = true;
            })
            .addCase(fetchColorPlate.fulfilled, (state, action) => {
                state.loadingColorPlate = false;
                state.colorPlate = action.payload;
                state.colorPlateLoaded = true; // ✅ important
            })
            .addCase(fetchColorPlate.rejected, (state) => {
                state.loadingColorPlate = false;
            });
    },

});


export const { setDateFormat, setLanguageValue } = commonSlice.actions;
export default commonSlice.reducer;

